<template>
    <div class="flex-1 min-w-0">
        <h2 class="mt-10 ml-10 font-semibold text-xl text-gray-800 leading-tight">
            Località disagiate
        </h2>
        <div class="py-12">
            <div class="mx-auto sm:px-6">

                <form @submit.prevent="search"
                      style="display:flex; align-items:center; gap:10px; max-width:640px;">
                    <input
                        v-model="word"
                        type="text"
                        placeholder="Inserisci il nome esatto della località"
                        class="border border-gray-300 rounded-md px-3 py-2 w-full" />
                    <button type="submit"
                            class="bg-red-600 hover:bg-red-700 text-white font-medium px-4 py-2 rounded-md">
                        Cerca
                    </button>
                </form>

                <!-- Suggerimento iniziale -->
                <p v-if="!searched" class="text-gray-500 mt-4">
                    Digita il nome completo della località (almeno 3 caratteri) e premi Cerca.
                    La ricerca richiede il nome esatto.
                </p>

                <!-- Risultati -->
                <table v-if="result.length > 0" class="mt-6" style="border:1px solid #ebeced; min-width:340px;">
                    <thead>
                        <tr>
                            <th style="border-bottom:1px solid #ebeced; padding:6px 12px; text-align:left;">Località</th>
                            <th style="border-bottom:1px solid #ebeced; padding:6px 12px; text-align:left;">CAP</th>
                            <th style="border-bottom:1px solid #ebeced; padding:6px 12px; text-align:left;">Provincia</th>
                            <th style="border-bottom:1px solid #ebeced; padding:6px 12px; text-align:left;">Stato</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, i) in result" :key="i">
                            <td style="border-bottom:1px solid #ebeced; padding:6px 12px;">{{ item.localita }}</td>
                            <td style="border-bottom:1px solid #ebeced; padding:6px 12px;">{{ item.cap }}</td>
                            <td style="border-bottom:1px solid #ebeced; padding:6px 12px;">{{ item.provincia }}</td>
                            <td style="border-bottom:1px solid #ebeced; padding:6px 12px; color:#e2001a; font-weight:700;">DISAGIATA</td>
                        </tr>
                    </tbody>
                </table>

                <!-- Nessun risultato -->
                <p v-else-if="searched" class="text-gray-500 mt-6">
                    Nessuna località disagiata corrisponde a "{{ lastWord }}".
                    Assicurati di aver inserito il nome completo ed esatto della località.
                </p>

            </div>
        </div>
    </div>
</template>

<script>
/*
 * Pagina "Località disagiate" - area riservata clienti.
 * - un solo termine per volta, match esatto lato server (niente sfoglio a lettere)
 * - nessun export, nessuna paginazione
 * - gestione diretta della risposta: mostra un messaggio chiaro quando scatta
 *   il limite anti-scraping (HTTP 429 -> 5 ricerche/minuto sulla rotta)
 * - $store.getters.uri = "/" + ruolo (es. /client); axios baseURL = /api
 *   -> chiamata reale: POST /api/client/localita-disagiate
 */
export default {
    data() {
        return {
            word: '',
            lastWord: '',
            result: [],
            searched: false
        };
    },
    methods: {
        async search() {
            const word = (this.word || '').trim();
            if (word.length < 3) {
                this.$emit('notify', false, 'Inserisci almeno 3 caratteri.');
                return;
            }
            this.lastWord = word;
            this.initHeader();            // assicura l'header di autenticazione
            this.$emit('setLoading', true);
            try {
                const res = await this.axios.post(
                    this.$store.getters.uri + '/localita-disagiate',
                    { word }
                );
                // La risposta e' incapsulata dal logger: { value: [...], log_info: {...} }
                const body = res.data || {};
                this.result = Array.isArray(body.value)
                    ? body.value
                    : (Array.isArray(body) ? body : []);
                this.searched = true;
            } catch (e) {
                const status = e.response ? e.response.status : 0;
                if (status === 429) {
                    // Limite anti-scraping raggiunto: messaggio lungo e chiaro.
                    this.$emit('notify', false, 'Troppe ricerche ravvicinate',
                        'Hai effettuato troppe ricerche in poco tempo. Per motivi di ' +
                        'sicurezza la consultazione delle località disagiate è limitata: ' +
                        'attendi un minuto e riprova. Se devi verificare più indirizzi, ' +
                        'effettua una ricerca alla volta con qualche secondo di pausa.');
                } else if (status === 401) {
                    // Sessione scaduta: torna al login (flusso standard).
                    this.$store.commit('logout');
                    this.$router.push('/login');
                } else {
                    this.$emit('notify', false, 'Errore',
                        'Si è verificato un problema durante la ricerca. Riprova tra poco.');
                }
            } finally {
                this.$emit('setLoading', false);
            }
        }
    }
};
</script>
